import { H3, Link } from "@vp/swan"
import React from "react"

const SubCategoryHeader = props => {
  return (
    <H3 fontSize={"standard"} className={"link-list-heading"}>
      {props.subCategory.isAvailable ? (
        <Link
          data-fidoprefetchhint="HOVER"
          href={props.subCategory.url}
        >
          {props.subCategory.name}
        </Link>
      ) : (
        props.subCategory.name
      )}
    </H3>
  );
}

export default SubCategoryHeader
